import PropTypes from 'prop-types';
import React, {useEffect} from 'react';

import {LOAD_BAR} from '../../../constants/loadBar';
import {RECAPTCHA_ACTIONS} from '../../../constants/recaptcha';
import {TYPE_CLICK} from '../../../constants/tagManager';
import {PSR_TYPES} from '../../../constants/typesMessages';
import {useGetConditions} from '../../../hooks/useGetConditions';
import {useGetProductsCnae} from '../../../hooks/useGetProductsCnae';
import {useRecaptchaProtection} from '../../../hooks/useRecaptchaProtection';
import {sendAddresses} from '../../../services/Api';
import {showErrors} from '../../../services/errorsMessages';
import {
  checkPropertiesAddressFromAPI,
  addTypeToAddressFromBureau,
  inputAddressWithoutInfoBureau
} from '../../../services/flowAddress';
import {
  pushInteractionTagManagerChatbot,
  pushNoInteractionTagManagerChatbot
} from '../../../services/tagManager';
import {useChatStore} from '../../../store/slices/chatStore';
import {useEcStore} from '../../../store/slices/ecStore';
import {formatNumbers, hiddenByClass} from '../../../utils';

const HandWithSmartphone = '/messages/hand-smartphone.png';
import {HideButtonWhenLogout} from '../../../shared/components/HideButtonWhenLogout';
import './MessageAddressFromBureau.style.scss';

/**
 * @version 1.0.0
 * @author Tacio Camargo
 * ------- Flow Antecessor : Flow Partners----------
 *
 * Componente: MessageAddressFromBureau
 * Descrição do Componente:
 * Componente irá renderizar os endereços de retorno do Bureau.
 *
 * --------Próximo Flow = Address Type--------------
 */
const MessageAddressFromBureau = (props) => {
  const ecState = useEcStore((state) => state.ec);
  const ecStateId = useEcStore((state) => state.ec.id);
  const updateAddress = useEcStore((state) => state.updateAddress);
  const chatState = useChatStore((state) => state.messages);
  const sendMessage = useChatStore((state) => state.sendMessage);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const loadMessages = useChatStore((state) => state.loadMessages);
  const setMessages = useChatStore((state) => state.setMessages);
  const setChatStageFlow = useChatStore((state) => state.setChatStageFlow);
  let index = props.content.index;
  const {executeWithProtection} = useRecaptchaProtection();
  useGetProductsCnae();
  useGetConditions();

  const addressFromBureauCorrect = () => {
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-16:none:endereco'
    });
    hiddenByClass(document.getElementsByClassName('button-option-addresses'));
    let message = {
      text: 'Sim',
      type: 'response-sent'
    };
    sendMessage(message);
    index = ecState.addresses.length - 1;
    message = checkPropertiesAddressFromAPI(ecState, index);
    sendMessage(message);
    if (message.responseType) {
      responseTypeChange(message.responseType);
    }
  };

  const addressFromABureauWrong = () => {
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-16:none:endereco'
    });
    hiddenByClass(document.getElementsByClassName('button-option-addresses'));
    let message = {
      text: 'Não',
      type: 'response-sent'
    };
    sendMessage(message);
    const pos = chatState.findIndex(
      (item) => item.step === 'address' && item.index === index
    );
    const result = chatState.slice(0, pos);
    loadMessages(result);

    const addressToUpdateReducer = [...ecState.addresses];
    addressToUpdateReducer.splice(-1, 1);
    updateAddress(addressToUpdateReducer);
    if (index === 0) {
      message = inputAddressWithoutInfoBureau();
      addressDispatchHandler(message);
    } else {
      const types = [];
      for (let address of ecState.addresses) {
        types.push(...address.types);
      }
      index = ecState.addresses.length - 1;
      message = addTypeToAddressFromBureau(types, index);
      addressDispatchHandler(message);
    }
  };

  const addressDispatchHandler = (message) => {
    if (message.type === 'message-receive-address-type') {
      let showAddressBeforeType = {
        type: 'start-addresses-flow',
        index: message.index,
        step: 'address'
      };
      sendMessage(showAddressBeforeType);
      /**
       * Quando for ativar o flow de franquias substituir
       * o message abaixo
       * type: 'start-franquia-flow',
       *text: 'Seu estabelecimento é uma franquia?'
       */
    } else if (message.send) {
      executeWithProtection(
        (payload, token) => sendAddresses(ecStateId, payload, token),
        RECAPTCHA_ACTIONS.DATA_UPDATE,
        ecState.addresses
      )
        .then(function () {
          message = {
            type: PSR_TYPES.PSR_PAYMENT
          };
          sendMessage(message);
          setChatStageFlow(LOAD_BAR.ADDRESS);
        })
        .catch(function (error) {
          const showResponse = showErrors(error, 'endereços');
          setMessages(showResponse.messages);
        });
    } else {
      sendMessage(message);
      if (message.responseType) {
        responseTypeChange(message.responseType);
      }
    }
  };

  /**
   * Caso não exista nenhuma informação no Array de endereços
   * iremos criar um objeto com a estrutura de endereços
   * conforme a regra de negócios, ao final adicionamos
   * o objeto via reducer.
   * Caso exista dados apenas irá adicionar valor para os campos que estiverem vazios informando
   * que tais informações são faltantes.
   */

  const cepFormatado = formatNumbers(
    'XXXXX-XXX',
    ecState.addresses[index].zipCode
  );

  useEffect(() => {
    pushNoInteractionTagManagerChatbot({
      elementContent: 'step-16:none:endereco'
    });
  }, []);

  return (
    <div id={`address_${index}`}>
      <div className="message-line message-receive message-div address-content">
        <div>
          <div data-aut-test="message-receive-text">
            <strong>Rua: </strong>
            <span>{ecState.addresses[index].address.toUpperCase()}</span>
          </div>
          <div data-aut-test="message-receive-text">
            <strong>Número: </strong>
            <span>{ecState.addresses[index].number.toUpperCase()}</span>
          </div>
          <div data-aut-test="message-receive-text">
            <strong>Complemento: </strong>
            <span>{ecState.addresses[index].complement.toUpperCase()}</span>
          </div>
          <div data-aut-test="message-receive-text">
            <strong>CEP: </strong>
            <span>{cepFormatado}</span>
          </div>
          <div data-aut-test="message-receive-text">
            <strong>Bairro/Distrito: </strong>
            <span>{ecState.addresses[index].neighborhood.toUpperCase()}</span>
          </div>
          <div data-aut-test="message-receive-text">
            <strong>Município: </strong>
            <span>{ecState.addresses[index].city.toUpperCase()}</span>
          </div>
          <div data-aut-test="message-receive-text">
            <strong>UF: </strong>
            <span>{ecState.addresses[index].state.toUpperCase()}</span>
          </div>
        </div>
        <div className="icon">
          <img
            src={HandWithSmartphone}
            alt="Mão segurando um celular com GPS sendo exibido na tela"
          />
        </div>
      </div>
      <div className="message-line">
        <div className="message-receive">
          <div className="message-div" data-aut-test="message-receive-text">
            <span>O Endereço está correto?</span>
            <br />
            <span>
              OBS: Caso esteja faltando alguma informação, poderemos adicioná-la
              em seguida.
            </span>
          </div>
        </div>
      </div>
      <HideButtonWhenLogout>
        <div
          className="message-line button-option-addresses"
          id="button-option-address-from-bureau-confirme"
          data-aut-test="button-option-address-from-bureau-confirm"
        >
          <div className="div-button">
            <button
              id="address-from-bureau-confirme-nao"
              data-aut-test="address-from-bureau-confirm-no"
              data-testid="address-from-bureau-confirm-no"
              type="button"
              onClick={() => addressFromABureauWrong()}
            >
              NÃO
            </button>
            <button
              id="address-from-bureau-confirme-sim"
              data-aut-test="address-from-bureau-confirm-yes"
              data-testid="address-from-bureau-confirm-yes"
              type="button"
              onClick={() => addressFromBureauCorrect()}
            >
              SIM
            </button>
          </div>
        </div>
      </HideButtonWhenLogout>
    </div>
  );
};

MessageAddressFromBureau.propTypes = {
  content: PropTypes.any
};

export default MessageAddressFromBureau;
